(function ($, Drupal) {
  Drupal.behaviors.autoSubmitSelect = {
    attach(context) {
      once('autoSubmitSelect', '#edit-customer-masquerade-as', context).forEach((el) => {
        $(el).on('change', function () {
          $(this).closest('form').submit();
        });
      });
    }
  };
})(jQuery, Drupal);